<template>
  <div class="col-md-12 col-sm-12 col-xs-12">
    <div class="col-md-12 col-sm-12 col-xs-12">
      <b-table    bordered outlined hover responsive :busy="loading" :fields="fields" :items="items" show-empty>
        <template #table-busy>
          <div class="text-center my-2 mt-5 mb-5">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Đang tải...</strong>
          </div>
        </template>

        <template #empty="scope">
          <h4 class="text-center text-bold mt-5 mb-5">Không có dữ liệu</h4>
        </template>

        <template #cell(selected)="{ rowSelected }">
          <template v-if="rowSelected">
            <span aria-hidden="true">&check;</span>
            <span class="sr-only">Selected</span>
          </template>
          <template v-else>
            <span aria-hidden="true">&nbsp;</span>
            <span class="sr-only">Not selected</span>
          </template>
        </template>

        <template v-slot:cell(id)="data">
          {{data.item.id}}
        </template>
<!--        <template v-slot:cell(user_name)="data">-->
<!--          {{data.item.user_name}}-->
<!--        </template>-->
<!--        <template v-slot:cell(diff)="data">-->
<!--          <DataChanged :data="data.item.diff" :legal-list="legalList" :main-phone-number-list="mainPhoneNumberList"-->
<!--                       :phone-number-client-list="phoneNumberClientList" :phone-number-status-list="phoneNumberStatusList"-->
<!--                       :provider-list="providerList"></DataChanged>-->
<!--        </template>-->
        <template v-slot:cell(phone_number)="data">
          {{phoneNumberDetail.phone_number}}
        </template>
        <template v-slot:cell(created_at)="data">
          {{data.item.created_at | format_date_time}}
        </template>

      </b-table>
    </div>

    <div class="col-md-12 col-sm-12 col-xs-12 d-flex align-items-center justify-content-between">
      <div class="page-size-container">
        <span>Hiển thị</span>
        <b-form-select
          id="pageSize"
          v-model="pageSize"
          :options="pageSizes"
          required
        ></b-form-select>
        <span>  dòng</span>
      </div>
      <b-pagination
        v-model="currentPage"
        :total-rows="totalRow"
        :per-page="pageSize"
        aria-controls="my-table"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import Box from '../../components/Box.vue'
import Utils from '../../common/utils'
import PhoneNumberLockHistoryApi from '../../api/phoneNumberLockHistoryApi'
import LockInfo from './LockInfo.vue'

export default {
  name: 'PhoneNumberLockHistory',
  components: {
    Box,
    LockInfo
  },
  props: {
    id: {
      type: Number,
      required: false,
    },
    phoneNumberDetail: {
      type: Number,
      required: false,
    }
  },
  data () {
    return {
      loading: false,
      pageSize: 10,
      currentPage: 1,
      totalRow: 0,
      pageSizes: [
        {text: 100, value: 100},
        {text: 50, value: 50},
        {text: 20, value: 20},
        {text: 10, value: 10}
      ],
      fields: [
        {
          key: 'phone_number',
          label: 'Số khóa',
          show: true,
        }, {
          key: 'viettel_lock_date',
          label: 'Ngày khóa viettel',
          show: true,
        }, {
          key: 'mobifone_lock_date',
          label: 'Ngày khóa mobifone',
          show: true,
        }, {
          key: 'vinaphone_lock_date',
          label: 'Ngày khóa vinaphone',
          show: true,
        }, {
          key: 'other_lock_date',
          label: 'Ngày khóa ngoại mạng',
          show: true,
        }, {
          key: 'send_provider_date',
          label: 'Ngày gửi NCC',
          show: true,
        }, {
          key: 'unlock_lock_date',
          label: 'Ngày mở',
          show: true,
        }, {
          key: 'created_at',
          label: 'Ngày thay đổi',
          show: true
        }
      ],
      items: []
    }
  },
  mounted () {
    if (this.id) {
      this.filter()
    }
  },
  methods: {
    buildFilterData () {
      return {phone_number_id: this.id}
    },
    filter () {
      if (this.loading) {
        return
      }
      this.loading = true
      PhoneNumberLockHistoryApi.filter(this.buildFilterData(), this.currentPage - 1, this.pageSize).then(res => {
        this.loading = false
        this.items = res.data.data.records
        this.totalRow = res.data.data.total
      }).catch(err => {
        this.loading = false
        Utils.handleError(this.$bvToast, err)
      })
    },
  },
  watch: {
    currentPage: {
      handler: function () {
        this.filter()
      }
    },
    pageSize: {
      handler: function () {
        this.filter()
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/phone_number_management/PhoneNumberLockHistory.vue